export const text = {
  title: "Oracle Cloud Workload Estimator",
  subTitle: "Oracle designed our Gen 2 Infrastructure to be fast, efficient and priced competitively.  While we are competitive across all our services, there are several scenarios where pricing differences are significant.  Start with one of our scenarios or build your own to see how we compare to AWS for your key workloads.",
  bandwidth: {
    title: "Bandwidth Intensive",
    savings: "70-80%",
    body: "For workloads with significant network egress, Oracle offers substantial savings over AWS. Start here for applications like video conferencing, notification services or file synchronization.",
    labelQuestion: "Enter the estimated amount of traffic egress to start and then we explore options on compute and storage costs in the tool"
  },
  blockStorage: {
    title: "I/O Intensive",
    savings: "95-97%",
    body: "Applications with high I/O performance requirements typically face a surcharge for high performance storage. Start here for OLTP, analytics and enterprise applications",
    labelQuestion: "Enter your average monthly block storage consumption to start and we will explore options on compute"
  },
  hpc: {
    title: "General Purpose",
    savings: "40-60%",
    body: "Workloads that require a good balance of compute, memory, and networking such as web and application servers, small and mid-sized databases and app development environments",
    labelQuestion: "Enter the # of instances you want and then explore options on cores and storage per instance"
  },
  own: {
    title: "Build your own",
    savings: "40-97%",
    body: "Want to build your own model from the ground up?  Start here for custom applications and workloads and explore our competitive services your way"
  }
}
